// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"6580bf4178c09f57a4e2","3":"04cfb02b6b9193cf0006","4":"9b450af2fa5ccf2f1315","5":"7d973e413b443a0938d2"}[chunkId] + "";
};